// extracted by mini-css-extract-plugin
export default {"documents":"styles_documents__Q9ggN","title":"styles_title__Hj3JP","disclaimer":"styles_disclaimer__g2qAb"};